// extracted by mini-css-extract-plugin
export default {"viewItem":"view-form_viewItem__YYgnJ","viewItemValue":"view-form_viewItemValue__prhDB","linkDownload":"view-form_linkDownload__ihigu"};